<template>
  <div>
    <div class="columns">
      <div class="column is-5">
        <img v-if="slip.document" v-document="slip.document" class="full-width smooth-corners">
      </div>

      <div class="column">
        <b-field label="Chauffeur">
            <b-autocomplete
                ref="crediteurField"
                v-model="crediteur.name"
                :data="filterCrediteuren"
                :placeholder="`bijv. ${crediteur.data[0] || ''}`"
                @select="onCrediteurSelect"
                :keep-first="true"
                required>
            </b-autocomplete>
        </b-field>

        <div class="field" v-if="number">
          <label class="label">Bonnummer</label>
          <div class="control">
            <input class="input" type="text" v-model="number" disabled>
          </div>
        </div>

        <b-field label="Datum">
          <b-datepicker
            placeholder="Selecteer..."
            v-model="date"
            required>
          </b-datepicker>
        </b-field>

        <div class="field">
          <label class="label">Creditcard</label>
          <div class="select">
            <select v-model="creditcard">
              <option v-for="creditcard in creditcardCompanies" :value="creditcard">{{creditcard.name}}</option>
            </select>
          </div>
        </div>

        <div class="field">
          <label class="label">Grootboekrekening</label>
          <div class="select">
            <select v-model="journal">
              <option v-for="journal in journals" :value="journal.value">{{journal.name}}</option>
            </select>
          </div>
        </div>

        <div class="field">
          <label class="label">Prijs</label>
          <div class="control has-icons-left">
            <input class="input" type="number" v-model="price" required>
            <span class="icon is-left">
              <i class="fa fa-eur"></i>
            </span>
          </div>
        </div>

        <div class="spacing-top-20">
          <button class="button is-primary" @click="saveCreditcardslip">Klaarzetten voor controle</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'debiteuren',
      'crediteuren',
      'creditcardCompanies'
    ]),
    ...mapGetters({
      creditcardslips: 'allCreditcardslips',
      incomplete: 'incompleteCreditcardslips',
      journals: 'creditcardslipsJournals'
    }),
    filterCrediteuren () {
      const result = this.crediteur.data.filter((option) => {
        return option
          .toString()
          .toLowerCase()
          .indexOf(this.crediteur.name.toLowerCase()) >= 0
      })
      return result
    }
  },
  data () {
    return {
      slip: {},
      crediteur: {
        data: [],
        name: '',
        selected: null
      },
      number: '',
      date: '',
      creditcard: {},
      journal: '',
      price: null
    }
  },
  async created () {
    await this.$store.dispatch('getAllCreditcardslips')
    await this.$store.dispatch('getCrediteuren')
    await this.$store.dispatch('getCreditcardCompanies')
    await this.$store.dispatch('getCreditcardslipsJournals')

    this.crediteur.data = this.crediteuren.map((object) => {
      return object.acctName
    })

    const id = this.$route.params.id
    const slip = this.creditcardslips.find((slip) => slip.id === id)

    this.slip = slip
    let {number, date, creditcard, crediteur, journal, price} = this.slip

    this.number = number
    this.date = date ? new Date(date) : new Date()
    this.creditcard = creditcard
    this.journal = journal
    this.price = price

    this.setCrediteur(crediteur)
  },
  methods: {
    async saveCreditcardslip () {
      const { id } = this.slip
      const { date, creditcard, journal, price } = this

      await this.$store.dispatch('saveCreditcardslip', {
        id,
        date,
        creditcard,
        journal,
        crediteur: this.crediteur.selected,
        price
      })

      this.$router.push({ name: 'creditcard.processing' })
    },
    setCrediteur (id) {
      for (let object of this.crediteuren) {
        if (object.subNr === id) {
          this.$refs.crediteurField.setSelected(object.acctName)
        }
      }
    },
    onCrediteurSelect (object) {
      const crediteur = this.crediteuren.find((crediteur) => {
        return crediteur.acctName === object || crediteur.subNr === object
      })

      if (!crediteur) {
        return
      }

      this.crediteur.selected = crediteur.subNr
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/creditcard/edit.vue